import { Link } from "react-router-dom";
import type { LandingContent, Locale, RouteKind } from "../content/types";
import { getPath } from "../lib/paths";
import { LanguageSwitch } from "./LanguageSwitch";

type SiteHeaderProps = {
  content: LandingContent;
  locale: Locale;
  page: RouteKind;
};

export function SiteHeader({ content, locale, page }: SiteHeaderProps) {
  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Link className="brand-link" to={getPath("landing", locale)} aria-label="Moodshot">
          <img src="/images/moodshot-icon.svg" alt="" width="28" height="28" />
          <span>Moodshot</span>
        </Link>
        <nav className="site-nav" aria-label={content.nav.navLabel}>
          <Link aria-current={page === "privacy" ? "page" : undefined} to={getPath("privacy", locale)}>
            {content.nav.privacy}
          </Link>
          <Link aria-current={page === "support" ? "page" : undefined} to={getPath("support", locale)}>
            {content.nav.support}
          </Link>
          <Link aria-current={page === "terms" ? "page" : undefined} to={getPath("terms", locale)}>
            {content.nav.terms}
          </Link>
        </nav>
        <LanguageSwitch
          locale={locale}
          labels={content.nav.language}
          ariaLabel={content.nav.languageLabel[locale]}
        />
      </div>
    </header>
  );
}
